import { createContext, useContext } from 'react';

type GroupsCreationContextValue = {
  isCreating: boolean;
  openNew: () => void;
  closeNew: () => void;
};

const GroupsCreationContext = createContext<GroupsCreationContextValue | null>(
  null
);

export const GroupsCreationProvider = GroupsCreationContext.Provider;

export const useGroupsCreation = (): GroupsCreationContextValue | null =>
  useContext(GroupsCreationContext);
